import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getDefaultCoverImageURL } from "../../_helpers";

export function SidebarCover({ url, name }) {
  const [cover, setCover] = useState(undefined);
  const { data: chronicle } = useSelector((state) => state.chronicle);
  const { items: images } = useSelector((state) => state.images);
  useEffect(() => {
    if (!url) {
      if (chronicle) {
        const { defaultCover } = chronicle;
        if (defaultCover && defaultCover._id) {
          setCover(defaultCover.url);
        } else {
          const image = images.find((i) => i._id === defaultCover);
          if (image) {
            setCover(image.url);
          } else {
            setCover(getDefaultCoverImageURL());
          }
        }
      } else {
        setCover(getDefaultCoverImageURL());
      }
    } else {
      setCover(url);
    }
  }, [url]);

  name = name || "Event cover image not loaded.";

  const isWebP = /.webp$/.test(cover);
  return (
    <div
      className="chronos-sidebar-cover"
      style={{
        backgroundImage: cover && !isWebP ? `url(${cover})` : "none",
      }}
    >
      {isWebP && (
        <img src={cover} className="chronos-sidebar-cover-image" alt={name} />
      )}
    </div>
  );
}
